import React, { useState } from "react";
import "../styles/enquiryForm.css";

const EnquiryForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    userType: "",
    lookingFor: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="enquiry-overlay">
      <div className="enquiry-card">
        <button className="close-btn" onClick={onClose}>×</button>

        <p className="form-eyebrow">CONTACT US</p>
        <h1 className="form-title">
          Have Questions? <br /> We’re here to help
        </h1>

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="grid-2">
            <div className="input-group">
              <label>Name</label>
              <input name="name" onChange={handleChange} required />
            </div>

            <div className="input-group">
              <label>Email</label>
              <input type="email" name="email" onChange={handleChange} required />
            </div>
          </div>

          <div className="grid-2">
            <div className="input-group">
              <label>Phone Number</label>
              <input name="phone" onChange={handleChange} required />
            </div>

            <div className="input-group">
              <label>Pincode</label>
              <input name="pincode" onChange={handleChange} required />
            </div>
          </div>

          <div className="input-group">
            <label>Are you?</label>
            <select name="userType" onChange={handleChange} required>
              <option value="">Select</option>
              <option>Individual</option>
              <option>Architect</option>
              <option>Builder</option>
              <option>Dealer</option>
            </select>
          </div>

          <div className="input-group">
            <label>Message</label>
            <textarea rows="3" name="message" onChange={handleChange} />
          </div>

          <button type="submit" className="submit-btn">
            SUBMIT
          </button>

          {/* <p className="form-note">
            By submitting, you agree to our <span>Disclaimer</span>.
          </p> */}
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm;
